import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { TemplateTextComponent } from "../../templates/template-text/template-text.component";
import { MaxLength } from "../../types/MaxLength";

@Component({
  selector: "app-prefix-po2",
  imports: [TemplateTextComponent],
  templateUrl: "./prefix-po2.component.html",
  styleUrl: "./prefix-po2.component.less",
})
export class PrefixPo2Component extends PrefixTextComponent {
  public maxlength: MaxLength;

  public constructor() {
    super();
    this.maxlength = 15;
    this.required = true;
    this.characters = ALLOWED_CHARACTERS["po2"];
  }
}
